"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSSGrid = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = require("../Box");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A utility component that encapsulates CSS grid behavior
 */
var CSSGrid = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "CSSGrid",
  componentId: "sc-1q8w5xn-0"
})(["display:grid;", ""], _styledSystem.grid);
exports.CSSGrid = CSSGrid;
//# sourceMappingURL=CSSGrid.js.map